
import React from "react";
import { CopyIcon } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

interface AdminOnlyInfoSectionProps {
  sessionId?: string;
  programId: string;
}

export const AdminOnlyInfoSection: React.FC<AdminOnlyInfoSectionProps> = ({
  sessionId,
  programId
}) => {
  const { userRoles } = useAuth();
  const isAdmin = userRoles?.includes('admin_user') || userRoles?.includes('admin');
  
  if (!isAdmin) return null;
  
  const copyToClipboard = (id: string, label: string) => {
    try {
      navigator.clipboard.writeText(id);
      toast.success(`${label} copied to clipboard`);
    } catch (err) {
      console.error(`Failed to copy ${label}:`, err);
      toast.error(`Failed to copy ${label} to clipboard`);
    }
  };
  
  return (
    <div className="mb-4 px-4 py-2 bg-orange-50 border-l-2 border-orange-500 text-sm text-orange-800">
      <div className="flex flex-col space-y-1">
        {sessionId && (
          <div className="flex items-center justify-between">
            <span>Session (offers) Document ID: <span className="font-mono text-xs">{sessionId}</span></span>
            <button 
              type="button"
              onClick={() => copyToClipboard(sessionId, "Session ID")} 
              className="p-1 hover:bg-orange-100 rounded-md transition-colors"
              title="Copy Session ID to clipboard"
            >
              <CopyIcon className="h-4 w-4 text-orange-500" />
            </button>
          </div>
        )}
        <div className="flex items-center justify-between">
          <span>Program (campLocations) Data Source ID: <span className="font-mono text-xs">{programId}</span></span>
          <button 
            type="button"
            onClick={() => copyToClipboard(programId, "Program ID")} 
            className="p-1 hover:bg-orange-100 rounded-md transition-colors"
            title="Copy Program ID to clipboard"
          >
            <CopyIcon className="h-4 w-4 text-orange-500" />
          </button>
        </div>
      </div>
    </div>
  );
};
